import { render, staticRenderFns } from "./messagebox.vue?vue&type=template&id=c3b56a60&scoped=true"
import script from "./messagebox.vue?vue&type=script&lang=js"
export * from "./messagebox.vue?vue&type=script&lang=js"
import style0 from "./messagebox.vue?vue&type=style&index=0&id=c3b56a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b56a60",
  null
  
)

export default component.exports